export var WEBSOCKET_INIT = 0;
export var WEBSOCKET_OPENING = 1;
export var WEBSOCKET_OPENED = 2;
export var WEBSOCKET_CLOSED = 4;
export var WEBSOCKET_RECONNECTING = 5;
export var WEBSOCKET_ERROR = 6;
export var WEBSOCKET_COMPLETE = 7;
export var WEBSOCKET_MAX_ATTEMPTS = 8;
export var CAINIAO = 'CAINIAO';
export var PDD = 'PDD';
export var JD = 'JD';
export var BYTE = 'BYTE';
export var KUAISHOU = 'KUAISHOU';
export var VIP = 'VIP';
export var HUAWEI = 'HUAWEI';
export var XHS = 'XHS';
export var NAMEMAPINSTANCE = {
  CAINIAO: {
    instance: 'wetPrintInstance',
    ready: 'isWetReady',
    need: 'isNeedWetPrint',
    url: 'wetDebugerUrl',
    unListen: 'unsubscribeWet'
  },
  CLOUD: {
    instance: 'cloudPrintInstance',
    ready: 'isCloudReady',
    need: 'isNeedCloudPrint',
    url: 'cloudDebugerUrl',
    unListen: 'unsubscribeCloud'
  },
  PDD: {
    instance: 'pddPrintInstance',
    ready: 'isPddReady',
    need: 'isNeedPddPrint',
    url: 'pddDebugerUrl',
    unListen: 'unsubscribePdd'
  },
  JD: {
    instance: 'jdPrintInstance',
    ready: 'isJdReady',
    need: 'isNeedJdPrint',
    url: 'jdDebugerUrl',
    unListen: 'unsubscribeJd'
  },
  BYTE: {
    instance: 'bytePrintInstance',
    ready: 'isByteReady',
    need: 'isNeedBytePrint',
    url: 'byteDebugerUrl',
    unListen: 'unsubscribeByte'
  },
  KUAISHOU: {
    instance: 'kuaiShouPrintInstance',
    ready: 'isKuaiShouReady',
    need: 'isNeedKuaiShouPrint',
    url: 'kuaiShouDebugerUrl',
    unListen: 'unsubscribeKuaiShou'
  },
  VIP: {
    instance: 'vipPrintInstance',
    ready: 'isVipReady',
    need: 'isNeedVipPrint',
    url: 'vipDebuggerUrl',
    unListen: 'unsubscribeVip'
  },
  HUAWEI: {
    instance: 'huaWeiPrintInstance',
    ready: 'isHuaWeiReady',
    need: 'isNeedHuaWeiPrint',
    url: 'huaWeiDebuggerUrl',
    unListen: 'unsubscribeHuaWei'
  },
  XHS: {
    instance: 'xhsPrintInstance',
    ready: 'isXhsReady',
    need: 'isNeedXhsPrint',
    url: 'xhsDebuggerUrl',
    unListen: 'unsubscribeXhs'
  }
};